import React, { FC, forwardRef } from 'react'

import { FormElementProps } from '@Components/FormElements/FormElementProps'
import { BaseFormInput } from '@Components/FormElements/UI/BaseFormInput'
import { useFormElementState } from '@Components/FormElements/useFormElementState'

export type TextAreaProps = FormElementProps & React.JSX.IntrinsicElements['textarea']

export const TextArea: FC<TextAreaProps> = forwardRef(
  (
    {
      adornments,
      error,
      id,
      label,
      name,
      size,
      variant,
      withoutLabelAnimation,
      wrapperClassName,
      ...props
    }: TextAreaProps,
    ref,
  ) => {
    const { formActive, ...state } = useFormElementState<'textarea'>({ ...props })

    return (
      <BaseFormInput
        adornments={adornments}
        error={error}
        formActive={formActive}
        id={id}
        label={label}
        size={size}
        variant={variant}
        withoutLabelAnimation={withoutLabelAnimation}
        wrapperClassName={wrapperClassName}
        {...props}
      >
        <textarea
          id={id}
          name={name}
          placeholder={label}
          ref={ref}
          {...props}
          {...state}
        />
      </BaseFormInput>
    )
  },
)
